import React, { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { ArrowUp, ArrowDown } from "@app/components/common/icons";
import { Chart } from "./components/chart/Chart";
import { ChartData } from "./types";
import { Legend } from "./components/legend/Legend";
import { getPerformanceRate } from "./helpers";

type Props = {
  data: ChartData[];
  rate: number;
};

export const PerformanceGraph: FC<Props> = ({ data, rate }) => {
  const { t } = useTranslation("performance-graphs");
  const rateInPercents = getPerformanceRate(rate);

  return (
    <div className={classNames("w-full space-y-12")}>
      <div className="space-y-1">
        <div
          className={classNames(
            "text-medium text-primary-content flex flex-wrap items-start gap-x-5",
            "md:items-center",
          )}
        >
          <h4>{t("performanceGraphTitle")}</h4>
          <div className="flex flex-nowrap items-center gap-x-2">
            <div>
              {rateInPercents >= 0 ? (
                <ArrowUp className="h-4 w-4" />
              ) : (
                <ArrowDown className="h-4 w-4" />
              )}
            </div>
            <span>{rateInPercents}%</span>
          </div>
        </div>
        <p className={classNames("text-regular text-base-400")}>
          {t("performanceGraphSubtitle")}
        </p>
      </div>
      <Chart series={data} />
      <Legend />
    </div>
  );
};
